<template>
  <q-page padding>
    <div class="row" v-if="!isInIframe">
      <div class="col-sm-12 col-xs-12 col-lg-12">
        <q-card>
          <q-card-section class="text-h6">
            Selecione uma empresa
          </q-card-section>
          <q-separator />
          <q-card-section>
            <grid-clientes tipo="LIST" :loading="loading" :clientes="clientes" tipoBotao="SELECT" @on-select="onSelectCliente"  />
          </q-card-section>
        </q-card>
      </div>
    </div>
    <div class="row" v-if="isInIframe">
      <div class="col-sm-12 col-xs-12 col-lg-12">
        <q-card>
          <q-card-section>
            <div class="row justify-center">
              <img alt="Super Simples logo" src="@/assets/logo.jpg">
            </div>
            <div class="row justify-center q-mt-md text-h5">
              Olá {{usuarioLogado.nome}}
            </div>
            <div class="row justify-center q-mt-md">
              <q-btn
                class="full-width"
                color="green-10"
                label="Acessar área do cliente"
                @click="openAreaDoCliente"
              />
            </div>
          </q-card-section>
        </q-card>
      </div>
    </div>
    <PesquisasAbertas />
  </q-page>
  <!-- <div class="hello">
    <b-container fluid>
      <b-row>
        <b-col sm="12" md="2"></b-col>
        <b-col sm="12" md="8" lg="8">
          <b-card no-body header="Selecione uma empresa" v-if="clientes.length && !isInIframe">
            <b-card-body>
              <grid-clientes tipo="LIST" :loading="loading" :clientes="clientes" tipoBotao="SELECT" @on-select="onSelectCliente"  />
            </b-card-body>
          </b-card>
          <template v-if="isInIframe">
            <b-card-img src="@/assets/logo.jpg" style="padding: 15px;" alt="Image" class="rounded-0"></b-card-img>
              <b-row>
                <b-col class="text-center">
                  Olá {{usuarioLogado.nome}}
                </b-col>
              </b-row>
              <b-row>
                <b-col class="text-center">
                  <b-button variant="success" @click="openAreaDoCliente">Acessar área do cliente</b-button>
                </b-col>
              </b-row>
          </template>
        </b-col>
      </b-row>
    </b-container>
  </div> -->
</template>

<script>
import GridClientes from './Cliente/GridClientes'
import PesquisasAbertas from './Pesquisa/PesquisasAbertas'
import { getUserClientes } from '../services/usuario'
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data () {
    return {
      loading: false,
      clientes: []
    }
  },
  mounted () {
    this.getUserClientes()
  },
  methods: {
    async getUserClientes() {
      try {
        this.loading = true
        this.clientes = await getUserClientes(this.usuarioLogado.cpf)
      } catch (error) {
        console.error(error)
        this.$bvToast.toast(error.message, {
          title: 'SRCAL',
          variant: 'danger',
          solid: true
        })
      } finally {
        this.loading = false
      }
    },

    onSelectCliente (cliente) {
      this.$store.dispatch('setCliente', cliente)
      this.$router.push({ name: 'Pedido' })
      // this.$bvModal.show('modal-selecao-acao')
    },

    openAreaDoCliente () {
      window.open('https://painel.calcariosrcal.com.br', '_blank')
    }
  },
  computed: {
    usuarioLogado () {
      return this.$store.getters.getUsuario
    },
    isInIframe () {
      return this.$store.getters.getInIframe
    }
  },
  components: {
    GridClientes,
    PesquisasAbertas
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-success {
  background-color: #255d46 !important;
  border-color: #255d46 !important;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>

<style media="print">
  /* .print {
    display: none;
  } */

  /* @media print {
    * {
      background: transparent !important;
      color: #000 !important;
      text-shadow: none !important;
      filter: none !important;
      -ms-filter: none !important;
    }

    body {
      margin: 0;
      padding: 0;
      line-height: 1.4em;
    }

    @page {
      size: A4 portrait;
    }

    .print {
      display: block !important;
    }

    .no-print {
      display: none !important;
    }
    
  } */
</style>
